var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "配置日志详情",
            width: "820px",
            visible: _vm.dialogVisible,
            "before-close": _vm.handleClose,
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "max-height": "420",
                "header-cell-style": { background: "#F5F6F7" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "配置下发ID",
                  prop: "configPublishId",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "下发类型",
                  prop: "publishTypeDescription",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "下发结果",
                  prop: "publishCode",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  prop: "createTime",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "更新时间",
                  prop: "updateTime",
                  "min-width": "160",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }